import Model  from 'alto-orm/lib/orm/model'

export default class Order extends Model
  # attrs: clientID (fkey), mealID (fkey), ordered (positive smallint), eaten (positive smallint),
  # createdAt (datetime), updatedAt (datetime)

  @attrNameMapping:
    clientID: 'client'
    mealID:   'meal'
